import { GzWidgetSectionItemWebComponent } from './component/GzWidgetSectionItemWebComponent';

export { GzWidgetSectionItemWebComponent };
